// extracted by mini-css-extract-plugin
module.exports = {"FranchizeDescription":"FranchizeDescription_FranchizeDescription__NZWVc"};